export const USER_MODAL_TOGGLE = "USER_MODAL_TOGGLE";
export const COURSE_MODAL_TOGGLE = "COURSE_MODAL_TOGGLE";

export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";

export const SET_LOADING = "SET_LOADING";
export const LOGOUT_USER = "LOGOUT_USER";

export const ADD_COURSE_TO_USER_SUCCESS = "ADD_COURSE_TO_USER_SUCCESS";
export const ADD_COURSE_TO_USER_FAIL = "ADD_COURSE_TO_USER_FAIL";

export const SET_WATCHED_SUCCESS = "SET_WATCHED_SUCCESS";
export const SET_WATCHED_FAIL = "SET_WATCHED_FAIL";

export const FETCH_FAILED = "FETCH_FAILED";
export const FETCH_SUCCESS = "FETCH_SUCCESS";

export const SET_AVATAR_IMAGE_FAIL = "SET_AVATAR_IMAGE_FAIL";
export const SET_AVATAR_IMAGE_SUCCESS = "SET_AVATAR_IMAGE_SUCCESS";

export const DISPLAY_AS_CHANGE_CARD = "DISPLAY_AS_CHANGE_CARD";
